import { SkeletonBlock } from '~/shared/ui'

export function LoadingSkeleton() {
  return (
    <div className="border-divider flex w-[480px] shrink-0 flex-col border-l">
      <div className="border-action-hovered h-[121px] animate-pulse border-b">
        <div className="flex h-[72px] items-center justify-between px-6">
          <div className="flex flex-col gap-2">
            <SkeletonBlock className="h-[25px] w-[95px]" />
            <SkeletonBlock className="h-5 w-[130px]" />
          </div>
        </div>
      </div>

      <div className="px-6 py-4">
        <SkeletonBlock className="h-4 w-[105px]" />
      </div>
      <div className="px-6">
        <div className="flex gap-1">
          <div className="relative w-10 shrink-0">
            <div className="bg-action-hovered absolute top-1 left-1/2 h-[calc(100%-4px)] w-0.5 -translate-x-1/2 animate-pulse"></div>
            <div className="bg-action-hovered-no-alpha absolute top-1 left-1/2 h-2.5 w-2.5 -translate-x-1/2 animate-pulse rounded-full"></div>
          </div>
          <div className="flex-1 pb-4">
            <div className="py-0.5">
              <SkeletonBlock className="h-4 w-[180px]" />
              <div className="flex flex-col gap-0.5 py-[3px]">
                <SkeletonBlock className="h-10 w-full" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="px-6 py-4">
        <SkeletonBlock className="h-4 w-[105px]" />
      </div>
      <div className="px-6">
        <div className="flex gap-1">
          <div className="relative w-10 shrink-0">
            <div className="bg-action-hovered absolute top-0 left-1/2 h-full w-0.5 -translate-x-1/2 animate-pulse"></div>
            <div className="bg-action-hovered-no-alpha absolute top-1 left-1/2 h-2.5 w-2.5 -translate-x-1/2 animate-pulse rounded-full"></div>
          </div>
          <div className="flex-1 pb-4">
            <div className="py-0.5">
              <SkeletonBlock className="h-4 w-[180px]" />
              <div className="flex flex-col gap-0.5 py-[3px]">
                <SkeletonBlock className="h-10 w-full" />
              </div>
            </div>
          </div>
        </div>
        <div className="flex gap-1">
          <div className="relative w-10 shrink-0">
            <div className="bg-action-hovered absolute top-0 left-1/2 h-1 w-0.5 -translate-x-1/2 animate-pulse"></div>
            <div className="bg-action-hovered-no-alpha absolute top-1 left-1/2 h-2.5 w-2.5 -translate-x-1/2 animate-pulse rounded-full"></div>
          </div>
          <div className="flex-1 pb-4">
            <div className="py-0.5">
              <SkeletonBlock className="h-4 w-[180px]" />
              <div className="flex flex-col gap-0.5 py-[3px]">
                <SkeletonBlock className="h-10 w-full" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
